import { render } from "./DetailsModal.vue?vue&type=template&id=547378f8&scoped=true&ts=true"
import script from "./DetailsModal.vue?vue&type=script&lang=ts"
export * from "./DetailsModal.vue?vue&type=script&lang=ts"

import "./DetailsModal.vue?vue&type=style&index=0&id=547378f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547378f8"]])

export default __exports__